import React from 'react';


class NumberChooser extends React.Component
{
	constructor(props)
	{
		super(props);

		this.changeNumber = this.changeNumber.bind(this);

		this.state = {
			nbPlayers: 10
		}
	}

	changeNumber(newNumber)
	{
		this.setState({nbPlayers: newNumber});
		this.props.onChangeNumber(newNumber);
	}
	
	render()
	{
		return (
			<div>
				<div className="subtitle">
					Nombre de joueurs :
				</div>
				<div className="toggle">
					<div className="toggle-8" style={(this.state.nbPlayers === 8)?{display:"none"}:{display:"inline-block"}} onClick={() => this.changeNumber(8)} ></div>
					<div className="toggle-10" style={(this.state.nbPlayers === 10)?{display:"none"}:{display:"inline-block"}} onClick={() => this.changeNumber(10)} ></div>
				</div>
				
			</div>
		);
	}
  
}

export default NumberChooser;
